import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice from '../../../../images/raw_material/rice.png'; 

const PurchaseHistoryList = ({ show, onClose, rawMaterials , purchase }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);
    useEffect(() => {
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    searching: false,
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    paging: false,
                    scrollY: "250px", // Set the scroll height here
                    scrollCollapse: true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const handleCheckboxChange = () => {
        checkIsChecked(!Checked);
    };
    const [Checked, checkIsChecked] = useState(false);



    return (
        <Modal show={show} size="xl"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Purchase History</h3>
                    <Button variant="" type="button" className="close px-6 py-1" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className='col-lg-4 col-md-4 col-sm-3 d-flex flex-column mb-3'>
                            <label className='text-black text-start font-w600 fs-7'>Purchase Date</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>
                                    {purchase?.purchase_date}
                                </label>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-3 d-flex flex-column mb-3'>
                            <label className='text-black text-start font-w600 fs-7'>Vendor</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>
                                   {purchase?.vendor_businessname}
                                </label>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-3 d-flex flex-column mb-3'>
                            <label className='text-black text-start font-w600 fs-7'>Purchase ID</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>
                                     {purchase?.purchase_id}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="table-container"  >
                        <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                   <th className='min-w-100px'>Raw Material</th>
                                    <th className='min-w-80px'>Brand</th>
                                    <th className='min-w-80px'>Qty / Units</th>
                                    <th className='min-w-80px'>Received Qty</th>
                                    <th className='min-w-100px'>Estimated Amount</th>
                                    <th className='min-w-100px'>Actual Amount</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {rawMaterials.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>
                                                {item.rawmaterial_name}
                                            </label>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>
                                                 {item.brand || "-"}
                                            </label>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>
                                                <span className='me-2'>{item.quantity}</span>
                                                <span>{item.unitslug_name}</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>
                                                <span className='me-2'>{item.actual_quantity}</span>
                                                <span>{item.unitslug_name}</span>
                                            </label>
                                        </td>
                                        <td align='right'>
                                             <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                                <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{item.total_cost}</span>
                                            </label>
                                        </td>
                                        <td align='right'>
                                            {item.actual_price ? (
                                            <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                                <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                <span>{item.actual_price}</span>
                                            </label>
                                            ):(
                                                <span className='text-black'>-</span>
                                            )}
                                        </td>
                                    </tr> 
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={4}></td>
                                    <td>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            Estimated Amount
                                        </label>
                                    </td>
                                    <td className='text-end'>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span> {purchase?.estimate_amount}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}></td>
                                    <td>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            Discount Amount ( {purchase?.discount} %)
                                        </label>
                                    </td>
                                    <td className='text-end'>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span> {purchase?.discount_amount}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}></td>
                                    <td>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            GST ( {purchase?.gst} %)
                                        </label>
                                    </td>
                                    <td className='text-end'>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span> {purchase?.gst_amount}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}></td>
                                    <td>
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            Actual Amount
                                        </label>
                                    </td>
                                    <td className='text-end'>
                                        {purchase?.actual_amount ? (
                                        <label className='text-danger font-w600  fs-7 py-0 px-1'>
                                            <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span> {purchase?.actual_amount}</span>
                                        </label>
                                        ):(
                                            <span className='text-black'>-</span>
                                        )}
                                    </td>
                                </tr>
                            </tfoot>
                        </table> 
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default PurchaseHistoryList;
